// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NotFound_wrapper__Kb9RI","card":"NotFound_card__WgFTo","title":"NotFound_title__5FRNZ","subtitle":"NotFound_subtitle__ePi6I"};